import {
  characterButtonStyle,
  characterEmojiStyle,
  characterImageStyle,
  scoreTagStyle,
} from './styles';
import type { ActiveCharacter } from './types';

interface CharacterCellProps {
  activeCharacter: ActiveCharacter;
  isShark: boolean;
  isClickedShark: boolean;
  onCharacterClick: (
    characterId: string,
    characterScore: number,
    position: number,
    isShark: boolean,
  ) => void;
}

export const CharacterCell = ({
  activeCharacter,
  isShark,
  isClickedShark,
  onCharacterClick,
}: CharacterCellProps) => {
  const handleInteraction = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    onCharacterClick(
      activeCharacter.id,
      activeCharacter.character.score,
      activeCharacter.position,
      isShark,
    );
  };

  return (
    <button
      type="button"
      css={characterButtonStyle(isShark)}
      onMouseDown={handleInteraction}
      onTouchStart={handleInteraction}
    >
      {isShark ? (
        <img
          src={`${process.env.NEXT_PUBLIC_CDN_URL}/public/games/${isClickedShark ? 's_02.png' : 's_01.png'}`}
          alt="shark"
          draggable="false"
          css={characterImageStyle}
        />
      ) : activeCharacter.character.imagePath ? (
        <img
          src={`${process.env.NEXT_PUBLIC_CDN_URL}/public/games/${activeCharacter.character.imagePath}`}
          alt={activeCharacter.character.name}
          draggable="false"
          css={characterImageStyle}
        />
      ) : (
        <span css={characterEmojiStyle(isShark)}>{activeCharacter.character.emoji}</span>
      )}
      <span css={scoreTagStyle(isShark)}>
        {activeCharacter.character.score > 0 ? '+' : ''}
        {activeCharacter.character.score}
      </span>
    </button>
  );
};
